var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5002 53.2499C50.2085 53.2083 49.8335 53.2083 49.5002 53.2499C42.1668 52.9999 36.3335 46.9999 36.3335 39.6249C36.3335 32.0833 42.4168 25.9583 50.0002 25.9583C57.5418 25.9583 63.6668 32.0833 63.6668 39.6249C63.6252 46.9999 57.8335 52.9999 50.5002 53.2499Z",
    stroke: "#DDE1EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0832 80.75C70.6665 87.5417 60.8332 91.6667 49.9998 91.6667C39.1665 91.6667 29.3332 87.5417 21.9165 80.75C22.3332 76.8333 24.8332 73 29.2915 70C40.7082 62.4167 59.3748 62.4167 70.7082 70C75.1665 73 77.6665 76.8333 78.0832 80.75Z",
    stroke: "#DDE1EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 91.6666C73.012 91.6666 91.6668 73.0118 91.6668 49.9999C91.6668 26.9881 73.012 8.33325 50.0002 8.33325C26.9883 8.33325 8.3335 26.9881 8.3335 49.9999C8.3335 73.0118 26.9883 91.6666 50.0002 91.6666Z",
    stroke: "#DDE1EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1414aa91df864f89f72d96ea9209850e.svg";
export { ForwardRef as ReactComponent };